import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "overlay", "form", "categorySelect", "percentField", "filterField"]

  open(event) {
    event.preventDefault()
    const el = event.currentTarget
    const {
      discountPercent,
      discountUrl,
      discountCategories,
      discountPrompt,
      discountFilter,
    } = el.dataset

    let categories = []
    try {
      categories = JSON.parse(discountCategories || "[]")
    } catch {
      categories = []
    }

    const select = this.categorySelectTarget
    select.innerHTML = ""
    const empty = document.createElement("option")
    empty.value = ""
    empty.textContent = discountPrompt || "—"
    select.appendChild(empty)
    categories.forEach((c) => {
      const opt = document.createElement("option")
      opt.value = c.id
      opt.textContent = c.name
      select.appendChild(opt)
    })

    this.percentFieldTarget.value = discountPercent || ""
    this.formTarget.action = discountUrl || ""
    if (this.hasFilterFieldTarget) {
      this.filterFieldTarget.value = discountFilter || ""
    }

    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"

    requestAnimationFrame(() => select.focus())
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}
